import type { FaireBrandEntity } from "../../entity_types/brand";

export const le_bon_shoppe: FaireBrandEntity = {
  token: "le-bon-shoppe",
  type: "brand",
  name: "Le Bon Shoppe",
  logoUrl:
    "https://cdn.shopify.com/s/files/1/2221/3755/files/GF-GREY2.jpg?v=1757105877",
  minimumOrderDollars: 100,
  rating: 4.8,
  location: "Los Angeles, CA",
  tags: ["socks", "apparel"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
